export const ReportsOnboarding = [
  {
    title: "Genera tus reportes financieros",
    description:
      "Evalua la situación financiera actual  de tu empresa y tomar decisiones más asertivas.",
    image: "https://cdn01.prd.symfonia.io/Gifs/Reportes.gif",
    alt: "Reportes financieros",
  },
];
